export default __webpack_public_path__ + "static/media/2.7678a99d.webp";